/* unplugin-vue-components disabled */
const DURATION = 300

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    nodePadding: {
      type: Number,
      default: 2
    },
  },
  emits: ['scroll-end'],
  setup() {
    return {DURATION}
  },
  data() {
    return {
      root_width: 0,
      animate: false,
      root_height: 0,
      row_height: 50,
      scroll_top: 0,
      raf_id: null,
      observer: null
    }
  },
  computed: {
    item_count() {
      return this.items.length
    },
    viewport_height() {
      return this.item_count * this.row_height + (this.$refs.bottom?.offsetHeight || 0)
    },
    start_ind() {
      const idx = Math.floor(this.scroll_top / this.row_height) - this.nodePadding
      return Math.max(0, idx)
    },
    visible_node_count() {
      const count = Math.ceil(this.root_height / this.row_height) + (2 * this.nodePadding)
      return Math.min(this.item_count - this.start_ind, count)
    },
    v_items() {
      return this.items.slice(
        this.start_ind,
        this.start_ind + this.visible_node_count
      )
    },
    offset_y() {
      return this.start_ind * this.row_height
    },
    spacer_style() {
      return {transform: `translateY(${this.offset_y}px)`}
    },
    viewport_style() {
      return {
        height: `${this.viewport_height}px`
      }
    },
  },
  watch: {
    async items() {
      this.$refs.root.scrollTop = 0
      this.animate = true
      await $utils.timers.wait(DURATION + 200)
      this.animate = false
      this.init()
    },
    v_items(){
      this.row_height = this.getLargestRowHeight()
    }
  },
  async mounted() {
    this.root_width = this.$el.clientWidth
    this.init()
  },
  beforeUnmount() {
    if (this.observer) this.observer.disconnect()
    if (this.raf_id) cancelAnimationFrame(this.raf_id)
  },
  methods: {
    async init() {
      this.root_height = this.$el.clientHeight

      await this.$nextTick()
      this.row_height = this.getLargestRowHeight()
      this.initObserver()
    },
    handleResize() {
      if (this.root_width < this.$el.clientWidth) {
        this.init()
      }
      this.root_width = this.$el.clientWidth
      this.root_height = this.$el.clientHeight
    },
    handleScroll() {
      const root = this.$refs.root

      let current_scroll = root.scrollTop

      const max_scroll = this.viewport_height - this.root_height
      if (current_scroll > max_scroll) {
        current_scroll = max_scroll
        root.scrollTop = current_scroll
      }

      this.scroll_top = current_scroll
    },
    initObserver() {
      if (this.observer) this.observer.disconnect()
      this.observer = new IntersectionObserver(([bottom]) => {
        if (bottom.isIntersecting) {
          this.$emit('scroll-end')
        }
      }, {
        root: this.$refs.root,
        threshold: 0.1
      })
      this.observer.observe(this.$refs.bottom)
    },
    getLargestRowHeight() {
      const children = Array.from(this.$refs.group.$el.children)
      return children.reduce((max, el) => Math.max(max, el.offsetHeight), this.row_height)
    },
    scrollTop(top = 0){
      this.$refs.root.scrollTop = top
    }
  }
}
